type Severity = 'success' | 'error' | 'warning' | 'info';
type NotifyFn = (message: string, severity: Severity) => void;

let _notifier: NotifyFn | null = null;

export function setNotifier(fn: NotifyFn) {
  _notifier = fn;
}

export function clearNotifier() {
  _notifier = null;
}

export function bridgeNotify(message: string, severity: Severity = 'error') {
  if (_notifier) {
    _notifier(message, severity);
  }
}
